<template>
  <div>
    <div class="dashboard-title">{{ $t("dashboard.deposit.title") }}</div>
    <hr />
    <div class="recharge-steps" v-if="step == 1">
      <div class="login-form">
        <p>{{ $t("dashboard.deposit.howMany") }}</p>
        <div class="alert alert-danger w-100 py-1" role="alert" v-if="showErr">
          {{ err }}
        </div>
        <div class="deposit-amount">
          <input required type="number" id="amount" v-model="amount" />
          <label for="amount">{{ $t("dashboard.deposit.GCoins") }}</label>
        </div>
        <div class="use-balance">
          <input type="checkbox" id="useBalance" v-model="useBalance" />
          <label for="useBalance">{{
            $t("dashboard.deposit.useBalance", {
              balance: numberWithCommas(balance),
            })
          }}</label>
        </div>
        <div class="btn btn-gold btn-block text-white" @click="deposit">
          {{ $t("dashboard.deposit.placeDeposit") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      step: 1,
      amount: null,
      useBalance: false,
      balance: "",
      showErr: false,
      err: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      // 调用API获取余额数据
      this.balance = 1200;
    },
    deposit() {
      if (!this.amount) {
        this.err = this.$t("dashboard.deposit.err");
        this.showErr = true;
        return;
      }
      alert(this.amount + " " + this.$tc("dashboard.deposit.GCoins"))
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  watch: {
    amount: function () {
      if (this.amount) this.showErr = false;
    },
  },
};
</script>

<style scoped>
.recharge-steps {
  .login-form {
    box-shadow: 0px 4.4px 22px 0px #0000000d;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    padding: 2rem;
    width: 100%;
    max-width: 436px;
    margin: 1rem auto;
    p {
      text-align: center;
      width: 100%;
      color: #3b3e51;
      font-size: 1rem;
      font-weight: 400;
      margin: 0;
    }
    .btn-block {
      width: 100%;
      font-size: 1.5rem;
      font-weight: 700;
    }
    span {
      color: #808695;
      font-size: 0.85rem;
    }
    .deposit-amount {
      position: relative;
      width: 100%;
      input {
        background-color: white;
        border: 1.1px solid #f2f3f4;
        border-radius: 1rem;
        height: 62px;
        padding-left: 5rem;
        width: 100%;
      }
      label {
        position: absolute;
        color: #3b3e51;
        font-size: 1rem;
        line-height: 1rem;
        top: 31px;
        margin-top: -0.5rem;
        left: 1rem;
      }
    }
    .use-balance {
      width: 100%;
      font-size: 1rem;
      line-height: 2rem;
      text-align: center;
      input[type="checkbox"] {
        display: none;
      }
      label {
        position: relative;
        cursor: pointer;
        padding-left: 1.6rem;
      }
      label::before {
        content: "";
        display: inline-flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0;
        top: 0.3rem;
        width: 1.3rem;
        height: 1.3rem;
        border-radius: 1.3rem;
        margin-right: 0.5rem;
        background-color: transparent;
        border: 3px solid #ff00004d;
      }
      input[type="checkbox"]:checked + label:before {
        content: "\2713";
        color: white;
        font-size: 0.8rem;
        line-height: 1.3rem;
        background-color: rgb(19, 200, 255);
        border: 3px solid rgb(19, 200, 255);
      }
    }
  }
}
</style>
